var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVintageCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9862 18.427C10.8933 18.3289 10.8933 18.1711 10.9862 18.073L13.8086 15.134C14.2773 14.6458 14.2773 13.8542 13.8086 13.366C13.3399 12.8778 12.5801 12.8778 12.1114 13.366L9.28992 16.306C9.19571 16.4028 9.04429 16.4028 8.95008 16.306L7.14624 14.427C7.07742 14.3555 7.0568 14.2478 7.09402 14.1543C7.13125 14.0607 7.21896 13.9998 7.31616 14H8.16C8.4251 14 8.64 13.7761 8.64 13.5V1.5C8.64 0.671573 7.99529 0 7.2 0H1.44C0.64471 0 0 0.671573 0 1.5V12.5C0 13.3284 0.64471 14 1.44 14H3.24384C3.30751 14 3.3686 14.0262 3.41376 14.073L7.25376 18.073C7.34672 18.1711 7.34672 18.3289 7.25376 18.427L3.95136 21.866C3.64817 22.1818 3.52976 22.6421 3.64074 23.0736C3.75171 23.505 4.07521 23.842 4.48938 23.9576C4.90354 24.0732 5.34545 23.9498 5.64864 23.634L8.95008 20.194C9.04429 20.0972 9.19571 20.0972 9.28992 20.194L12.5914 23.634C13.0601 24.1222 13.8199 24.1222 14.2886 23.634C14.7573 23.1458 14.7573 22.3542 14.2886 21.866L10.9862 18.427Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.52 11.5C12.5804 11.5 13.44 10.6046 13.44 9.5V3.5C13.44 2.39543 12.5804 1.5 11.52 1.5C10.4596 1.5 9.6 2.39543 9.6 3.5V9.5C9.6 10.6046 10.4596 11.5 11.52 11.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.84 2.5C15.0447 2.5 14.4 3.17157 14.4 4V9C14.4 9.82843 15.0447 10.5 15.84 10.5C16.6353 10.5 17.28 9.82843 17.28 9V4C17.28 3.17157 16.6353 2.5 15.84 2.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4867 3.5L18.505 5.053C18.3426 5.13777 18.24 5.31078 18.24 5.5V7.5C18.24 7.68922 18.3426 7.86223 18.505 7.947L21.4867 9.5C21.8157 9.71116 22.2309 9.71087 22.5596 9.49925C22.8883 9.28764 23.0742 8.90093 23.04 8.5V4.5C23.0757 4.09853 22.8901 3.71062 22.5608 3.49864C22.2316 3.28667 21.8155 3.28719 21.4867 3.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVintageCamera);
export default __webpack_public_path__ + "static/media/vintageCamera.e51e3f77.svg";
export { ForwardRef as ReactComponent };